import PendoCheckbox from '../../checkbox/pendo-checkbox.vue.js';

var script = {
  name: 'PendoCheckboxCell',
  components: {
    PendoCheckbox
  },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-checkbox-cell.vue2.js.map
